export default [
  {
    displayName: 'LinkUp',
    activePath: '/tube',
    i18Key: 'SH_LinkUp',
    authKey: 'NewTube',
  },
  {
    displayName: 'Foundation',
    activePath: '/foundation',
    i18Key: 'SH_Foundation',
    authKey: 'Foundation',
  },
  {
    displayName: 'Attendance',
    activePath: '/attendance',
    linkPath: '/ta',
    i18Key: 'SH_Attendance',
    authKey: 'TA',
  },
  {
    displayName: 'Payroll',
    activePath: '/payroll',
    i18Key: 'SH_Payroll',
    authKey: 'PY',
  },
];



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/components/Header/modules.js
 **/